import {find, range, uniqueId, result} from 'lodash';
import ColumnModel from './column';

export default class TableModel {
    name = 'sample';
    schema = null;
    _columnIdsMap = {};
    _opts = {
        sortColumns: true,
    };

    constructor(tableData, schema, opts = {}) {
        Object.assign(this, tableData, {columns: [], _columnIdsMap: {}});
        Object.assign(this._opts, opts);
        this.id = this.id || uniqueId('table');
        if (schema) {
            this.schema = schema;
        }
        for (const column of result(tableData, 'columns', [])) {
            this.addColumn(new ColumnModel(column, this));
        }
        this.sortColumns()
    }

    getColumnByName(columnName) {
        return find(this.columns, {fullName: columnName});
    }

    getColumnById(columnId) {
        return this._columnIdsMap[columnId];
    }

    addColumn(column) {
        const oldColumn = this._columnIdsMap[column.id];
        if (oldColumn) {
            const index = this.columns.indexOf(oldColumn);
            if (index >= 0) {
                this.columns.splice(index, 1, column);
            } else {
                this.columns.push(column);
            }
        } else {
            this.columns.push(column);
        }
        this.sortColumns();
        this._columnIdsMap[column.id] = column;
    }

    removeColumn(columnId) {
        const column = this._columnIdsMap[columnId];
        delete this._columnIdsMap[columnId];
        this.columns = this.columns.filter(c => c.id !== column.id);
    }

    getSampleData(includeTableName = true) {
        const {columns} = this;
        let rows = [];
        if (columns.length) {
            rows = range(columns[0].sample.length).map(i => columns.map(({sample}) => result(sample, i)));
        }
        return {
            name: includeTableName ? this.label : undefined,
            columns,
            rows,
        };
    }

    filter(searchQuery) {
        const filteredTable = new TableModel(this);
        filteredTable.columns = this.columns.filter(column => column.matchesQuery(searchQuery));
        return filteredTable;
    }

    sortColumns() {
        if (this._opts.sortColumns) {
            this.columns.sort((a, b) => a.name > b.name ? 1 : -1);
        }
    }

    get label() {
        return this.title_name || this.name;
    }

    get fullName() {
        return TableModel.getFullName(result(this.schema, 'name'), this.name);
    }

    get datasource() {
        return result(this.schema, 'datasource');
    }

    get sqlName() {
        return this.title_name ? `\`${this.title_name.replace(/\s/g, '')}\``: null;
    }

    get joinName() {
        return this.schema ? `${this.schema.name}.${this.name}` : null;
    }

    static getFullName(schemaName = 'schema', tableName) {
        return `${schemaName}.${tableName}`;
    }
}
